import React, { Component } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import { getAllUsersList, getUserSignature } from "../../../reduxRelated/actions/userActions";
import { getGroupReportLookup } from "../../../reduxRelated/actions/groupReportActions";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { themeService } from "../../../theme/service/activeTheme.service";
import { trackReportStyle } from "../Timps/style";
import { languageService } from "../../../Language/language.service";
import DateRangeControl, { rangeCalculater } from "../../Common/DateRange/DateRangeControl";
// import { getAssetTree } from "../../../reduxRelated/actions/assetHelperAction";

import moment from "moment";
import { jsonToCSV } from "react-papaparse";
import { isFraRole } from "../../MainPage/UserInfo";
// const InputObj = {
//   location: "",
//   user: "",
//   assetType: "",
//   defectCode: "",
//   defectStatus: "",
// };
class CombineReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReport: false,
      spinnerLoading: false,
      dateRange: {
        from: new Date(moment().startOf("month")),
        today: new Date(moment().startOf("day")),
        to: new Date(moment().endOf("month")),
      },
      //retain state
      // InputObj: { ...InputObj },
      inspec: {},
      InspectionReportType: "Original",
      dateRange: { from: new Date(moment().startOf("day")), today: new Date(moment().startOf("day")), to: new Date(moment().endOf("day")) },
      iPeriod: "",
      year: moment().year(Number).format("YYYY"),
      pRange: "",
      pInspecSchedule: "Scheduled",
      submit: false,
    };
    this.updateDateRange = this.updateDateRange.bind(this);
    this.handleUpdateFilterState = this.handleUpdateFilterState.bind(this);
  }
  updateDateRange(dateRange, stateRange, inspecSchedule) {
    this.setState({
      dateRange: dateRange,
      pInspecSchedule: inspecSchedule,
      ...stateRange,
    });
    this.handleUpdateFilterState({
      dateRange: dateRange,
    });
    let additionalQuery = isFraRole() ? "&isFra=" + isFraRole() : null;
    this.getRangeDataFromServer(dateRange, additionalQuery, inspecSchedule);
    //get testschedules (date,,,)
  }
  getRangeDataFromServer(range, additionalQuery, inspecSchedule) {
    const queryParams = { ...range, inspecSchedule: inspecSchedule ? inspecSchedule : this.state.pInspecSchedule };
    var jsonArray = encodeURIComponent(JSON.stringify(queryParams));
    let arg = "?dateRange=" + jsonArray + (additionalQuery ? additionalQuery : "");
    this.props.getTestSchedulesForCombineReportss("/getReportFilter" + arg);
  }
  handleUpdateFilterState(propertiesToUpdate) {
    console.log("handleUpdateFilterState", propertiesToUpdate);
  }
  componentDidMount() {
    this.props.getAssets && this.props.getAssets("getAssetTree");
    const { getGroupReportLookup } = this.props;
    getGroupReportLookup && getGroupReportLookup("ReportGroupingLookup");
  }

  render() {
    let loader = <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />;
    return (
      <div>
        {loader}
        {!this.state.showReport && (
          <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
            <React.Fragment>
              <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                {languageService("Combine Report")}
              </h2>
              <span>
                <DateRangeControl
                  dateRangeChanged={this.updateDateRange}
                  handleUpdateFilterState={this.handleUpdateFilterState}
                  iPeriod={this.state.iPeriod}
                  year={this.state.year}
                  pRange={this.state.pRange}
                  pInspecSchedule={this.state.pInspecSchedule}
                  submit={this.state.submit}
                  includeScheduleOption={true}
                  includePeriod={true}
                />
              </span>
            </React.Fragment>
          </div>
        )}
      </div>
    );
  }
}

const getAsset = curdActions.getAsset;
const getAssets = curdActions.getAssets;
let variables = {
  assetReducer: { asset: [], assets: {} },
  filterStateReducer: {
    reportSRFilter: null,
  },
  userReducer: {
    usersSignatures: [],
    allUsers: [],
  },
  diagnosticsReducer: {
    groupReportLookup: [],
  },
};

let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    // updateFilterState,
    getUserSignature,
    getGroupReportLookup,
    getAllUsersList,
    getAsset,
    getAssets,
  },
};

const CombineReportsContainer = CRUDFunction(
  CombineReports,
  "testSchedulesForCombineReports",
  actionOptions,
  variables,
  ["filterStateReducer", "userReducer", "diagnosticsReducer", "assetReducer"],
  "testSchedule",
);
export default CombineReportsContainer;



// WEBPACK FOOTER //
// ./src/components/Reports/CombineReports/index.jsx